<template>
  <div class="d-flex flex-column justify-center align-center pt-5">
    <div class="d-flex flex-row justify-center align-center pt-5">
      <v-btn
        color="pink"
        class="ma-4"
        width="400"
        @click="exportCreateTransactionCSVSuperAdmin()"
      >
        export ข้อมูลการสั่งซื้อของทุกระบบ
      </v-btn>
    </div>
  </div>
</template>

<script>
  export default {
    data: () => ({
      tab: 'kerry',
      snackbar: false,
      snackbar_text: '',
      import_dialog: false,
      assign_work_dialog: false,
      import_file: null,
      loading_kerry: false,
      loading_sale: false,
      search_keyword: '',
      dataPool : [],
      saleSelected: {},
      saleTransactionData: [],
      saleList: [],
      saleSelected: {},
      customer_detail: false,
      note: '',
      work_count: '20',
      dataTableHeader : [
        {
          text: 'ชื่อลูกค้า',
          align: 'start',
          value: 'name',
        },
        {
          text: 'address1',
          align: 'start',
          value: 'address1',
        },
        {
          text: 'address2',
          align: 'start',
          value: 'address2',
        },
        {
          text: 'ตำบล',
          align: 'start',
          value: 'subdistrict',
        },
        {
          text: 'อำเภอ',
          align: 'start',
          value: 'district',
        },
        {
          text: 'จังหวัด',
          align: 'start',
          value: 'province',
        },
        {
          text: 'รหัสไปรษณีย์',
          align: 'start',
          value: 'postcode',
        },
        {
          text: 'เบอร์โทรศัพท์',
          align: 'start',
          value: 'mobile',
        },
        {
          text: 'มูลค่า (บาท)',
          align: 'start',
          value: 'amount',
        },
        {
          text: 'สถานะรายการ',
          align: 'start',
          value: 'status',
        },
        {
          text: 'วันนัดหมาย',
          align: 'start',
          value: 'noti_date',
        },
        {
          text: 'sale',
          align: 'start',
          value: 'note',
        },
        {
          text: 'sale',
          align: 'start',
          value: 'username',
        },
      ],
      saleTransactionHeader : [
        {
          text: 'ชื่อลูกค้า',
          align: 'start',
          value: 'name',
        },
        {
          text: 'address1',
          align: 'start',
          value: 'address1',
        },
        {
          text: 'address2',
          align: 'start',
          value: 'address2',
        },
        {
          text: 'ตำบล',
          align: 'start',
          value: 'subdistrict',
        },
        {
          text: 'อำเภอ',
          align: 'start',
          value: 'district',
        },
        {
          text: 'จังหวัด',
          align: 'start',
          value: 'province',
        },
        {
          text: 'รหัสไปรษณีย์',
          align: 'start',
          value: 'postcode',
        },
        {
          text: 'เบอร์โทรศัพท์',
          align: 'start',
          value: 'mobile',
        },
        {
          text: 'ราคา (บาท)',
          align: 'start',
          value: 'price',
        },
        {
          text: 'ค่าใช้จ่ายอื่นๆ (บาท)',
          align: 'start',
          value: 'price_other',
        },
        {
          text: 'ประเภทสินค้า',
          align: 'start',
          value: 'product_type',
        },
        {
          text: 'รายการสินค้า',
          align: 'start',
          value: 'product',
        },
        {
          text: 'วิธีการชำระเงิน',
          align: 'start',
          value: 'payment_method',
        },
        {
          text: 'หมายเหตุ',
          align: 'start',
          value: 'note',
        },
        {
          text: 'เวลาส่งข้อมูล',
          align: 'start',
          value: 'insert_time',
        },
        {
          text: 'sale',
          align: 'start',
          value: 'username',
        },
        {
          text: 'sale',
          align: 'start',
          value: 'image_path',
        },
      ],
      customer_detail_sale_transaction: [],
      customer_detail_data_pool: [],
      customer_detail_data_pool_Header : [
        {
          text: 'ชื่อลูกค้า',
          align: 'start',
          value: 'name',
        },
        {
          text: 'เบอร์โทรศัพท์',
          align: 'start',
          value: 'mobile',
        },
        {
          text: 'วันที่รับข้อมูลเข้าระบบ',
          align: 'start',
          value: 'date',
        },
        {
          text: 'ที่อยู่',
          align: 'start',
          value: 'address1',
        },
        {
          text: 'จังหวัด',
          align: 'start',
          value: 'province',
        },
        {
          text: 'ราคา',
          align: 'start',
          value: 'amount',
        },
        {
          text: 'symbol',
          align: 'start',
          value: 'symbol',
        },
      ],
      customer_detail_sale_transaction_Header : [
        {
          text: 'id',
          align: 'start',
          value: 'id',
        },
        {
          text: 'ชื่อลูกค้า',
          align: 'start',
          value: 'name',
        },
        {
          text: 'เบอร์โทรศัพท์',
          align: 'start',
          value: 'mobile',
        },
        {
          text: 'บ้านเลขที่',
          align: 'start',
          value: 'address1',
        },
        {
          text: 'ตำบล',
          align: 'start',
          value: 'subdistrict',
        },
        {
          text: 'อำเภอ',
          align: 'start',
          value: 'district',
        },
        {
          text: 'จังหวัด',
          align: 'start',
          value: 'province',
        },
        {
          text: 'รหัสไปรษณีย์',
          align: 'start',
          value: 'postcode',
        },
        {
          text: 'วันที่สั่งสินค้า',
          align: 'start',
          value: 'insert_time',
        },
        {
          text: 'ชนิดผลิตภัณฑ์',
          align: 'start',
          value: 'product_type',
        },
        {
          text: 'ผลิตภัณฑ์',
          align: 'start',
          value: 'product',
        },
        {
          text: 'ราคา',
          align: 'start',
          value: 'price',
        },
        {
          text: 'ค่าใช้จ่ายอื่นๆ',
          align: 'start',
          value: 'price_other',
        },
        {
          text: 'วิธีการชำระเงิน',
          align: 'start',
          value: 'payment_method',
        },
      ],
      assign_lead_dialog: false,
      mobileSelected: '',
      nameSelected: '',
      loading_sale_user: false,
      date_pick: '',
      status: 'A',
      statusList: ['A', 'D', 'P'],
      imagePath: null,
    }),
    mounted () {
      this.getLeadListAdmin()
      this.getSaleTransaciontAdmin()
      this.getSaleListAdmin()
    },
    methods: {
      updateTransaction(value) {
        console.log(value)
        this.$store.commit('SET_adminUpdateTransaction', value)
        
        this.$router.push('/updateTransactionAdmin')
      },
      selectRow(value) {
        console.log('select row')
        console.log(value)
        // this.date_from = value.noti_date
        this.mobileSelected = value.mobile
        this.nameSelected = value.name
        this.assign_lead_dialog = true
      },
      selectRow_transaction(value) {
        console.log('select row')
        console.log(value)
        this.note = value.note
        this.mobileSelected = value.mobile
        this.imagePath = value.image_path_real
        this.customer_detail = true
        this.get_customer_detail()
      },
      openTransactionImage() {
        window.open(this.imagePath.replace("-", "_"))
      },
      async get_customer_detail () {
        const user_cookie = this.$cookie.get('user');
        const user = JSON.parse(user_cookie)

        console.log(user)
        console.log()
        const customer_detail = await this.$store.dispatch('customerDetail', {
          uuid: user.uuid,
          mobile: this.mobileSelected
        })

        this.customer_detail_sale_transaction = customer_detail.saleTransaction
        this.customer_detail_data_pool = customer_detail.dataPool

        console.log(customer_detail)
      },
      change_to_kerry_data() {
        this.tabs = 'kerry'
      },
      async getLeadListAdmin () {
        const user_cookie = this.$cookie.get('user');
        const user = JSON.parse(user_cookie)

        this.loading_kerry = true

        console.log()

        console.log(user)
        const lead_list_result = await this.$store.dispatch('getLeadListAdmin', {
          uuid: user.uuid,
          keyword: this.search_keyword,
        })

        this.dataPool = lead_list_result
        this.loading_kerry = false

        console.log(lead_list_result)
      },
      async getSaleTransaciontAdmin () {
        const user_cookie = this.$cookie.get('user');
        const user = JSON.parse(user_cookie)

        this.loading_sale = true

        console.log(user)
        const lead_list_result = await this.$store.dispatch('getSaleTransaciontAdmin', {
          uuid: user.uuid,
          keyword: this.search_keyword,
        })

        this.saleTransactionData = lead_list_result
        this.loading_sale = false

        console.log(lead_list_result)
      },
      async getSaleListAdmin () {
        const user_cookie = this.$cookie.get('user');
        const user = JSON.parse(user_cookie)

        this.loading_sale_user = true

        console.log(user)
        const sale_list_result = await this.$store.dispatch('getSaleListAdmin', {
          uuid: user.uuid,
        })

        this.saleList = sale_list_result
        this.loading_sale_user = false

        // console.log(saleList)
      },
      async exportCreateTransactionCSVSuperAdmin () {
        const user_cookie = this.$cookie.get('user');
        const user = JSON.parse(user_cookie)

        console.log(user)
        const url_path = await this.$store.dispatch('exportCreateTransactionCSVSuperAdmin', {
          uuid: user.uuid,
        })

        // console.log(url_path)
        window.open(url_path);
      },
      async exportDataPoolPSCSV () {
        const user_cookie = this.$cookie.get('user');
        const user = JSON.parse(user_cookie)

        console.log(user)
        const url_path = await this.$store.dispatch('exportDataPoolPSCSV', {
          uuid: user.uuid,
        })

        // console.log(url_path)
        window.open(url_path);
      },
      async assign_mobile_to_sale () {
        const user_cookie = this.$cookie.get('user');
        const user = JSON.parse(user_cookie)

        console.log(user)
        console.log(this.saleSelected)
        const sale_list_result = await this.$store.dispatch('assign_mobile_to_sale', {
          uuid: user.uuid,
          mobile: this.mobileSelected,
          sale_id: this.saleSelected,
          date: this.date_pick,
          status: this.status,
        })

        this.assign_lead_dialog = false
        this.getLeadListAdmin()

        console.log(sale_list_result)
      },
      async assign_work_manual () {
        const user_cookie = this.$cookie.get('user');
        const user = JSON.parse(user_cookie)

        console.log(user)
        console.log(this.saleSelected)
        const sale_list_result = await this.$store.dispatch('assign_work_manual', {
          uuid: user.uuid,
          work_count: this.work_count,
          sale_id: this.saleSelected,
        })

        this.assign_work_dialog = false
        this.getLeadListAdmin()

        console.log(sale_list_result)
      },
      objectToFormData (obj = {}) {
          let formData = new FormData()
              for (let key in obj) {
                  if (typeof obj[key] === 'object' && !(obj[key] instanceof File)) {
                  for (let item in obj[key]) {
                      if (typeof obj[key][item] === 'object' && !(obj[key][item] instanceof File)) {
                          for (let index in obj[key][item]) {
                              formData.append(`${key}[${item}][${index}]`, obj[key][item][index])
                          }
                      } else {
                          formData.append(`${key}[${item}]`, obj[key][item])
                      }
                  }
              } else {
                  formData.append(key, obj[key])
              }
          }
          return formData
      },
      async importLead () {
        const user_cookie = this.$cookie.get('user');
        const user = JSON.parse(user_cookie)

        console.log(user)

        let param_obj = {
          uuid: user.uuid,
          kerry_filename: null,
        }
        if (this.import_file != null) {
          param_obj.kerry_filename = this.import_file
          let params = this.objectToFormData(param_obj)
          const create_transaction_result = await this.$store.dispatch('importLead', params)
          console.log(create_transaction_result)
          this.snackbar_text = create_transaction_result
          this.snackbar = true
        }
        else {
          this.snackbar_text = 'กรุณาใส่ file'
          this.snackbar = true
        }
      },
      go_to_add_datapool() {
        this.$router.push('/addDataPool')
      }
    }
  }
</script>